import React, { useState } from "react";
import { Modal, message } from "antd";
import { useChat } from "./ChatContext";
import UserPicker from "./UserPicker";
import { CHAT_MODAL_Z_INDEX } from "./types";

const NewDmModal: React.FC = () => {
  const { newDmOpen, setNewDmOpen, selectDm, realmUsers } = useChat();
  const [userIds, setUserIds] = useState<number[]>([]);

  const close = () => {
    setNewDmOpen(false);
    setUserIds([]);
  };

  const handleOk = () => {
    if (userIds.length === 0) {
      message.warning("Pick at least one person.");
      return;
    }
    const names = realmUsers.filter((u) => userIds.includes(u.user_id)).map((u) => u.full_name);
    selectDm(userIds, names.join(", ") || "Direct message");
    close();
  };

  return (
    <Modal
      title="New direct message"
      open={newDmOpen}
      onOk={handleOk}
      onCancel={close}
      okText="Start"
      destroyOnClose
      zIndex={CHAT_MODAL_Z_INDEX}
    >
      <UserPicker value={userIds} onChange={setUserIds} placeholder="Search people…" />
    </Modal>
  );
};

export default NewDmModal;
